import { helpers } from 'vuelidate/lib/validators';

export const houseNumber = helpers.regex(
    'houseNumber',
    /^[^!"'§$%&=?{}[\]*#.:,;_<>^°]*$/u,
);
